import React, { Component } from 'react';
import { func, object, shape, bool, string } from 'prop-types';

import styled from 'styled-components/macro';

import ReactModal from 'react-modal';
import { MdClose } from 'react-icons/md';

import { MODAL_TYPES } from 'utils/constants';
import { baseSpacing, modalSizes, radius, colors } from 'css/constants';

/* Specific modal content */
import CreditActivationForm from 'forms/CreditActivationForm';
import CreditsPurchaseForm from 'forms/CreditsPurchaseForm';
import CardForm from 'forms/CardForm';
import UserForm from 'forms/Users/UserForm';
import AddUsersToGroupForm from 'forms/Users/AddUsersToGroupForm/AddUsersToGroupForm';

const StyledButton = styled.div`
  position: absolute;
  top: ${baseSpacing / 4}px;
  right: ${baseSpacing / 4}px;
`;

// react-modal needs an adapter to work correctly with styled-components:
// https://github.com/reactjs/react-modal/issues/603
export const ReactModalAdapter = ({
  className, // eslint-disable-line react/prop-types
  ...props
}) => {
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return (
    <ReactModal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  );
};

const StyledModal = styled(ReactModalAdapter)`
  &__content {
    display: flex;
    border: 1px solid ${colors.lightGrey};
    border-radius: ${radius}px;
    box-shadow: 0 0 ${baseSpacing / 2}px rgb(0 0 0 / 20%);
    background-color: #fff;
    width: 100%;
    max-height: 90%;
    max-width: ${(props) => props.size};
    position: absolute;
  }

  &__overlay {
    position: fixed;
    inset: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(0 0 0 / 15%);
  }
`;

export default class Modal extends Component {
  modalContent = {
    [MODAL_TYPES.CREDIT_ACTIVATION]: CreditActivationForm,
    [MODAL_TYPES.CREDITS_PURCHASE]: CreditsPurchaseForm,
    [MODAL_TYPES.PAYMENT_METHOD]: CardForm,
    [MODAL_TYPES.USER]: UserForm,
    [MODAL_TYPES.ADD_USERS_TO_GROUP]: AddUsersToGroupForm
  };

  getModalContent = (modalType) => this.modalContent[modalType];

  render() {
    const { hideModal, modal } = this.props;

    const { active, props, type } = modal;

    const ModalContent = this.getModalContent(type);
    const modalSize = modalSizes.default;

    if (
      typeof ModalContent !== 'function' &&
      typeof ModalContent !== 'object'
    ) {
      return null;
    }

    return (
      <StyledModal
        // TODO: check why closeTimeoutMS doesn't work
        closeTimeoutMS={500}
        contentLabel="Modal"
        size={modalSize}
        isOpen={active}
        onRequestClose={hideModal}
        suppressClassNameWarning
      >
        <StyledButton
          data-testid="closeBtn"
          name="closeBtn"
          onClick={hideModal}
        >
          <MdClose />
        </StyledButton>
        <ModalContent hideModal={hideModal} {...props} />
      </StyledModal>
    );
  }
}

Modal.propTypes = {
  hideModal: func.isRequired,
  modal: shape({
    active: bool,
    props: object.isRequired,
    type: string.isRequired
  }).isRequired
};
